import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { resetEmailSendRetry } from 'src/app/redux/actions/reset/resetEmailSend';
import 'src/app/containers/Reset/ResetEmailSentContainer.scss';
import Layout from 'src/app/components/Layout/Layout';
import background from 'src/assets/images/background-put-email.jpg';
import ResetNewPasswordPresentation from 'src/app/components/ResetNewPasswordPresentation';
import LayoutLeftColumn from 'src/app/components/Layout/LayoutLeftColumn';
import LayoutRightColumn from 'src/app/components/Layout/LayoutRightColumn';


class ResetEmailFormContainer extends React.PureComponent {

  resendEmail = () => {
    const { dispatch, value } = this.props;

    dispatch(resetEmailSendRetry(value));
  };

  render() {
    const { value } = this.props;
    const { resendEmail } = this;

    return <Layout>
      <LayoutLeftColumn>
        <h4 styleName="title">Sprawdź pocztę</h4>

        <p styleName="information" data-test="text-success-message">
          Wysłaliśmy Ci wiadomość na adres
          <span styleName="information__email">{value}</span>
          z linkiem do zmiany hasła.
        </p>

        <div styleName="resend">
          <h4 styleName="resend__title">Wiadomość nie dotarła?</h4>

          <button styleName="resend__send-email"
                  onClick={ resendEmail }
                  type="button"
          >
            Prześlij ponownie link do zmiany hasła
          </button>
        </div>
      </LayoutLeftColumn>
      <LayoutRightColumn background={ background }>
        <ResetNewPasswordPresentation />
      </LayoutRightColumn>
    </Layout>;
  }
}

ResetEmailFormContainer.propTypes = {
  value: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  value: state.resetEmailReducer.value
});

export default connect(mapStateToProps)(ResetEmailFormContainer);
